export const Roles = {
  ECC: 'user_ecc',
  ECC_ADMIN: 'admin_ecc',
  LABO_ADMIN: 'admin',
  LABO_USER: 'user'
};

export const isSuperAdmin = (role) => role === Roles.ECC_ADMIN;

export const isLaboAdmin = (role) => role === Roles.ECC_ADMIN || role === Roles.LABO_ADMIN;

export const isEcc = (role) => role === Roles.ECC_ADMIN || role === Roles.ECC;